import { useEffect, useState } from 'react';
import { clientInitials } from './client-activity.js';
import './ClientAvatar.css';
import { requestAvatarMetadata, watchAvatar } from './avatar-subscriptions.js';

export function announceAvatarChange(id: string) {
  window.dispatchEvent(new CustomEvent('client-avatar-updated', { detail: id }));
  requestAvatarMetadata();
}
export function ClientAvatar({
  id,
  name,
  className = '',
}: {
  id: string;
  name: string;
  className?: string;
}) {
  const [version, setVersion] = useState(0);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
    const changed = (event: Event) => {
      if ((event as CustomEvent<string>).detail === id) {
        setFailed(false);
        setVersion((value) => value + 1);
      }
    };
    const unwatch = watchAvatar(id, () => {
      setFailed(false);
      setVersion((value) => value + 1);
    });
    window.addEventListener('client-avatar-updated', changed);
    return () => {
      unwatch();
      window.removeEventListener('client-avatar-updated', changed);
    };
  }, [id]);
  return (
    <span className={`client-avatar ${className}`} aria-hidden="true">
      {clientInitials(name)}
      {!failed ? (
        <img
          key={`${id}-${version}`}
          src={`/api/v1/admin/clients/${encodeURIComponent(id)}/avatar/image?v=${version}`}
          alt=""
          loading="lazy"
          onError={() => setFailed(true)}
        />
      ) : null}
    </span>
  );
}
